import { ProviderPrescriberType } from '@uplift/types';

export const getPrescriberLabel = (
  prescriberType: ProviderPrescriberType | null,
  prescriberTypes: Record<ProviderPrescriberType, string>
): string | null => {
  return prescriberType ? prescriberTypes[prescriberType] : null;
};
